export * from './src/data-v1-data-permissions-permissions.universal.js';
